import { useSelector } from 'react-redux';
import { useContext, useEffect, useState } from 'react';
import { Hooks } from 'providers';
import 'components/company/revamp/parts/setting/customWla/list/index.scss';
import './index.scss';

import Button from 'components/_parts/atoms/button';
import Label from 'components/_parts/atoms/label';
import Input from 'components/_parts/atoms/input';
import TextArea from 'components/_parts/atoms/textArea';
import LoadingCustom from 'components/layouts/loading/loading';

function CollapsibleEdit(props) {
  const {
    data, formik, t, typeForm, setInitialValuesMod, tab,
  } = props;
  const [isOpen, setIsOpen] = useState(null);
  const { dataListSubSkill, keySubSkillList } = useSelector((state) => ({
    dataListSubSkill: state?.company?.sub_skill_group_list,
    keySubSkillList: state?.loading?.listKey?.list_sub_skill_group,
  }));

  useEffect(() => {
    if (typeForm === 'update') {
      formik.setValues({
        ...formik.values,
        data: {
          ...formik.values.data,
          competency_skill_group_id: data?.competency_skill_group_id || '',
          skill_group_name: data?.skill_group_name || '',
          skill_group_description: data?.skill_group_description || '',
          sub_skill_group: dataListSubSkill?.map((val) => ({
            competency_sub_skill_group_id: val?.competency_sub_skill_group_id,
            sub_skill_group_name: val?.sub_skill_group_name,
            sub_skill_group_description: val?.sub_skill_group_description,
          })),
        },
      });
    }
  }, [data, typeForm, dataListSubSkill]);

  const handleChange = (e, fieldName) => {
    formik.setFieldValue(fieldName, e.target.value);
  };

  return (
    <>
      <div className="mt-4">
        <Input
          name="data.skill_group_name"
          type="text"
          style={{ width: '70%' }}
          value={formik.values?.data?.skill_group_name || ''}
          placeholder="Input Skill Group Name"
          onChange={formik.handleChange}
          isError={formik.errors.data?.skill_group_name}
          validateMessage={formik.errors.data?.skill_group_name}
        />
      </div>
      <div className="mt-4">
        <TextArea
          name="data.skill_group_description"
          placeholder="Input Skill Group Description"
          className="center_placeholder"
          style={{ resize: 'none' }}
          rows={3}
          value={formik.values.data.skill_group_description || ''}
          onChange={(e) => handleChange(e, 'data.skill_group_description')}
          isError={formik.errors.data?.skill_group_description}
          validateMessage={formik.errors.data?.skill_group_description}
        />
      </div>
      <div className="mt-3 scrollCustom collapseEdit_skillGorupManagement">
        { keySubSkillList ? <LoadingCustom /> : (
          formik.values.data.sub_skill_group?.map((val, ix) => (
            <div
              key={val.competency_sub_skill_group_id}
              className="custom_wla-collapsible-container"
              style={{ margin: '10px 2px 5px 2px' }}
            >
              <div className="custom_wla-collapsible-content">
                <div className="d-flex justify-content-between align-items-center">
                  <div style={{ width: '45%' }}>
                    <Input
                      name={`data.sub_skill_group[${ix}].sub_skill_group_name`}
                      type="text"
                      style={{ width: '70%' }}
                      value={formik.values?.data?.sub_skill_group[ix].sub_skill_group_name || ''}
                      placeholder="Input Sub Skill Group Name"
                      onChange={formik.handleChange}
                      isError={formik.errors?.data?.sub_skill_group?.[ix]?.sub_skill_group_name}
                      validateMessage={formik.errors?.data?.sub_skill_group?.[ix]?.sub_skill_group_name}
                    />
                  </div>
                  <div className="custom_wla-collapsible-content-right justify-content-center align-items-center">
                    {/* <Button
                      icon="minus"
                      style={{ height: '24px', width: '26px', backgroundColor: '#FF4F4F' }}
                      func={() => handleDelete(val)}
                    /> */}
                    {/* <Button
                        icon="create"
                        style={{
                          height: '24px',
                          width: '26px',
                          backgroundColor: '#9AFF5B',
                          visibility: ix === formik.values.data?.sub_skill_group?.length - 1 ? 'visible' : 'hidden',
                        }}
                        func={() => handleAdd(i)}
                      /> */}
                    <Button
                      icon={`${isOpen === ix ? 'down' : 'chevronRight'}`}
                      style={{
                        height: '24px', width: '26px', backgroundColor: 'white', color: '#4C4C4C',
                      }}
                      func={() => (isOpen === ix ? setIsOpen(null) : setIsOpen(ix))}
                    />
                  </div>
                </div>
                { isOpen === ix && (
                <div className="mt-4">
                  <TextArea
                    name={`data.sub_skill_group[${ix}].sub_skill_group_description`}
                    placeholder="Input Sub Skill Group Description"
                    className="center_placeholder"
                    style={{ resize: 'none' }}
                    rows={3}
                    value={formik.values.data?.sub_skill_group[ix].sub_skill_group_description || ''}
                    onChange={(e) => handleChange(e, `data.sub_skill_group[${ix}].sub_skill_group_description`)}
                    isError={formik.errors.data?.sub_skill_group?.[ix]?.sub_skill_group_description}
                    validateMessage={formik.errors.data?.sub_skill_group?.[ix]?.sub_skill_group_description}
                  />
                </div>
                )}
              </div>
            </div>
          ))
        ) }
      </div>
    </>
  );
}

export default CollapsibleEdit;
